<template>
    <div class="helper-page">
        <template v-for="item in stepOptions">
            <step-component
                :key="'STEP_OPTION_ITEM_KEY_'+item.title"
                :title="item.title"
                :sub-title="item.subTitle"
                :img="item.img"/>
        </template>
    </div>
</template>

<script>
import StepComponent from '@/views/helper/StepComponent'
export default {
    name: 'xhs',
    components: { StepComponent },
    data () {
        return {
            stepOptions: [
                {
                    title: '第一步',
                    subTitle: '点击小红书，进入个人资料页点击右上角图标。',
                    img: require('@/assets/xhs/xhs01.png')
                },
                {
                    title: '第二步',
                    subTitle: '点击“复制链接”即可获得链接',
                    img: require('@/assets/xhs/xhs02.png')
                }
            ]
        }
    }
}
</script>

<style scoped>

</style>
